import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { StepId } from '../../api/useRiskToleranceWorkflowQuery';
import { Footer } from '../../components/Footer/Footer';
import { StepProps } from '../../components/OrionRiskToleranceWorkflow/OrionRiskToleranceWorkflow.meta';
import { Content } from '../../components/Content/Content';
import { StepCard } from '../../components/StepCard/StepCard';
import { VisualPicker } from '../../../CommonComponents/OPL/VisualPicker/VisualPicker';
import { FormValues, options, title } from './EmergencyHandling.meta';
import PiggyBankSVG from '../../../CommonComponents/OPL/illustrations/piggy-bank.svg';

export const EmergencyHandling: React.FC<StepProps> = ({
  answers,
  onPrevious,
  onSubmit,
  submitAnswers,
  progress,
}) => {
  const { handleSubmit, setValue, control } = useForm<FormValues>({
    defaultValues: {
      [StepId.EmergencyHandling]: answers.emergencyHandling,
    },
  });

  const onSubmitStep = ({ emergencyHandling }: FormValues) => {
    onSubmit({ stepId: StepId.EmergencyHandling, answer: emergencyHandling });

    submitAnswers({ ...answers, [StepId.EmergencyHandling]: emergencyHandling });
  };

  return (
    <Box minWidth={864}>
      <form onSubmit={handleSubmit(onSubmitStep)}>
        <Content>
          <StepCard title={title} textAlign="left">
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Controller
                control={control}
                name={StepId.EmergencyHandling}
                render={({ field: { value: formValue } }) => (
                  <Box
                    display="flex"
                    flexDirection="column"
                    flexBasis={278}
                    gridGap="16"
                    role="radiogroup"
                    aria-label={title}
                  >
                    {options.map(({ label, value }) => {
                      const checked = value === formValue;

                      return (
                        <VisualPicker
                          key={value}
                          label={label}
                          onChange={() => setValue(StepId.EmergencyHandling, value)}
                          checked={checked}
                        />
                      );
                    })}
                  </Box>
                )}
              />

              <PiggyBankSVG width={242} height={248} />
            </Box>
          </StepCard>
        </Content>

        <Footer onPrevious={onPrevious} progress={progress} />
      </form>
    </Box>
  );
};
